module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--sidebar group--df-column pab2"
  }, [_c('div', {
    staticClass: "mw600"
  }, [_c('h1', {
    staticClass: "h1 group__title mw600 mw700",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.editMode) ? _c('div', {
    staticClass: "group group--wide group--df-column"
  }, [_c('h3', {
    staticClass: "c-accent mb",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Personal Information")]), _vm._v(" "), _vm._l((_vm.personalInfo), function(field, key) {
    return _c('module-read-only-form', {
      key: key,
      attrs: {
        "field": field
      }
    })
  }), _vm._v(" "), _c('h3', {
    staticClass: "c-accent mb mt2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._l((_vm.contactInfo), function(field, key) {
    return _c('module-read-only-form', {
      key: key,
      attrs: {
        "field": field
      }
    })
  }), _vm._v(" "), (_vm.org.dfd_client !== true) ? _c('router-link', {
    staticClass: "link link--accent link--arrow tdn fw-bold mt2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "to": {
        path: "/profile/change-password"
      }
    }
  }, [_vm._v("Change password")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "link link--accent link--arrow tdn fw-bold mt",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "to": {
        path: "/log-out"
      }
    }
  }, [_vm._v("Logout")])], 2) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('div', [(_vm.editMode === "change-password") ? _c('module-change-password') : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ca4835"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Profile.vue
// module id = 497
// module chunks = 0